var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/components/warning.tsx";
import React from 'react';
import { spring } from 'react-motion';
import Motion from '../../ui/util/optional_motion';
/** Warning message displayed in ComposeForm. */
const Warning = ({
  message
}) => /*#__PURE__*/React.createElement(Motion, {
  defaultStyle: {
    opacity: 0,
    scaleX: 0.85,
    scaleY: 0.75
  },
  style: {
    opacity: spring(1, {
      damping: 35,
      stiffness: 400
    }),
    scaleX: spring(1, {
      damping: 35,
      stiffness: 400
    }),
    scaleY: spring(1, {
      damping: 35,
      stiffness: 400
    })
  },
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 12,
    columnNumber: 3
  }
}, ({
  opacity,
  scaleX,
  scaleY
}) => /*#__PURE__*/React.createElement("div", {
  className: "compose-form__warning",
  style: {
    opacity: opacity,
    transform: `scale(${scaleX}, ${scaleY})`
  },
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 14,
    columnNumber: 7
  }
}, message));
export default Warning;